import React from "react";
import { ConfigProvider } from 'antd';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/reset.css";
import { ThemeWrapper } from "./theme";
import { Provider } from "react-redux";
import store, { persistor } from "./Redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Buffer } from "buffer";

window.Buffer = Buffer;

const nonce = document
  .querySelector("script[data-nonce]")
  .getAttribute("data-nonce");

if (nonce) {
  // Intercept creation of <style> elements
  const originalCreateElement = document.createElement.bind(document);
  document.createElement = function (tagName, options) {
    const element = originalCreateElement(tagName, options);
    if (tagName.toLowerCase() === "style") {
      element.setAttribute("nonce", nonce);
    }
    return element;
  };
}
const root = createRoot(document.getElementById("root"));
root.render(
  <ConfigProvider csp={{ nonce }}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename="/quick-pay">
          <ThemeWrapper>
            <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLE_CAPTCHA_KEY}>
              <App />
            </GoogleReCaptchaProvider>
          </ThemeWrapper>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
